import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./scss/style.css";
import App from "./App";
import "./css/index.css";
import "./css/widget.css";
import { createStore } from "redux";
import { Provider } from "react-redux";
require("react-big-calendar/lib/css/react-big-calendar.css");
// import { createBrowserHistory } from "history";

// Default State
const globalState = {
  isRead: 0,
};

const rootReducer = (state = globalState, action) => {
  return state;
};
const storeRedux = createStore(rootReducer);

ReactDOM.render(
  <BrowserRouter>
    <Provider store={storeRedux}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);
